import { render, staticRenderFns } from "./JewelDescriptionTooltip.vue?vue&type=template&id=a1ff7aea&scoped=true&"
import script from "./JewelDescriptionTooltip.vue?vue&type=script&lang=js&"
export * from "./JewelDescriptionTooltip.vue?vue&type=script&lang=js&"
import style0 from "./JewelDescriptionTooltip.vue?vue&type=style&index=0&id=a1ff7aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ff7aea",
  null
  
)

export default component.exports